import config from '@/config'

class Chat {
  constructor(host) {
    this.host = host
    this.ishttps = config.ISPROD
    this.fromEmail = localStorage.getItem('userEmail')
    this.token = localStorage.getItem('_verificationToken')

    this.chatTimer = null
    this.autoReconnectInterval = 2000 // ms

    this.recipients = [this.fromEmail]
    this.init()
  }

  init() {
    return new Promise(resolve => {
      let wsProtocol = 'ws://'

      if (window.location.protocol === 'https:') {
        wsProtocol = 'wss://'
      }
      this.ws = new WebSocket(wsProtocol + this.host)
      this.ws.onopen = () => {
        this.join()
        resolve()
      }

      this.ws.onerror = e => {
        if (e.target.readyState === 1) {
          console.error('websocket error: ', e)
        }
      }

      this.ws.onclose = e => {
        if (e.code === 1006) {
          // abnormally closed
          this.reconnectAbnormallyClosedConnection()
        }
      }
    })
  }

  join(toEmail = null, roomMembers = []) {
    if (toEmail !== null) {
      this.recipients = [this.fromEmail]
      this.recipients.push(toEmail)
    }

    if (roomMembers.length > 0) {
      this.recipients = roomMembers.slice()
    }

    if (this.isOpen() && this.fromEmail && this.token) {
      this.ws.send(
        JSON.stringify({
          fromEmail: this.fromEmail,
          token: this.token,
          msg: false,
          recipient: this.recipients
        })
      )
    }
  }

  receive({ fromEmail, recipient, isMsg }) {
    if (this.isOpen()) {
      this.ws.send(
        JSON.stringify({
          fromEmail: fromEmail,
          msgRecv: true,
          msg: isMsg,
          recipient: recipient
        })
      )
    }
  }

  reconnect() {
    return new Promise(resolve => {
      this.ws = null
      this.init().then(() => {
        resolve()
      })
    })
  }

  reconnectAbnormallyClosedConnection() {
    clearTimeout(this.chatTimer)
    this.chatTimer = setTimeout(() => {
      this.reconnect()
    }, this.autoReconnectInterval)
  }

  send({ message, isMsg, datetime, subject = '', recipients = [], attachBool = false }) {
    if (this.isOpen()) {
      this.ws.send(
        JSON.stringify({
          fromEmail: this.fromEmail,
          msgSubject: subject,
          message: message,
          attachBool: attachBool,
          clientDate: datetime,
          msg: isMsg,
          recipient: recipients.length > 0 ? recipients : this.recipients
        })
      )
    }
  }

  isOpen() {
    return this.ws.readyState === 1
  }
}

export default Chat
